"use client";

import React from "react";
import { Button } from "@/components/ui/button";
import { Logo } from "./Logo";
import { NavMenu } from "./NavMenu";
import { MobileNav } from "./MobileNav";
import { ModeToggle } from "@/components/mode-toggle";
import { useTranslations } from "next-intl";
import { useLanguage } from "@/lib/LanguageContext";
import Link from "next/link";
import {
    DropdownMenu,
    DropdownMenuContent,
    DropdownMenuItem,
    DropdownMenuTrigger,
} from "@/components/ui/dropdown-menu";
import { Globe } from "lucide-react";

export const Navbar = () => {
    const t = useTranslations('marketing.navbar');
    const { language, setLanguage } = useLanguage();
    const [loginUrl, setLoginUrl] = React.useState("#");
    const [signupUrl, setSignupUrl] = React.useState("#");

    React.useEffect(() => {
        const hostname = window.location.hostname;
        const currentLang = language || 'en';

        let baseUrl = "https://app.ecommaps.com";
        if (hostname === "localhost") {
            baseUrl = "http://app.localhost:3000";
        }

        setLoginUrl(`${baseUrl}/${currentLang}/login`);
        setSignupUrl(`${baseUrl}/${currentLang}/signup`);
    }, [language]);

    const toggleLanguage = (lang: 'en' | 'fr' | 'ar') => {
        setLanguage(lang);
    };

    return (
        <nav
            className="h-16 bg-background border-b border-accent sticky top-0 z-50"
            dir={language === 'ar' ? 'rtl' : 'ltr'}
        >
            <div className="h-full flex items-center justify-between max-w-7xl mx-auto px-4 sm:px-6">
                <Logo />

                {/* Desktop Menu */}
                <NavMenu className="hidden md:block" />

                <div className="flex items-center gap-3">
                    {/* Language Switcher */}
                    <DropdownMenu>
                        <DropdownMenuTrigger asChild>
                            <Button variant="outline" size="icon">
                                <Globe className="h-4 w-4" />
                            </Button>
                        </DropdownMenuTrigger>
                        <DropdownMenuContent align={language === 'ar' ? "start" : "end"}>
                            <DropdownMenuItem onClick={() => toggleLanguage('en')} className="cursor-pointer justify-center">
                                English
                            </DropdownMenuItem>
                            <DropdownMenuItem onClick={() => toggleLanguage('fr')} className="cursor-pointer justify-center">
                                Français
                            </DropdownMenuItem>
                            <DropdownMenuItem onClick={() => toggleLanguage('ar')} className="cursor-pointer justify-center">
                                العربية
                            </DropdownMenuItem>
                        </DropdownMenuContent>
                    </DropdownMenu>

                    {/* Theme Toggle */}
                    <ModeToggle />

                    {/* Auth Buttons */}
                    <Link href={loginUrl}>
                        <Button variant="outline" className="hidden sm:inline-flex">
                            {t('login')}
                        </Button>
                    </Link>
                    <Link href={signupUrl}>
                        <Button className="hidden xs:inline-flex">
                            {t('startNow')}
                        </Button>
                    </Link>

                    {/* Mobile Menu */}
                    <div className="md:hidden">
                        <MobileNav />
                    </div>
                </div>
            </div>
        </nav>
    );
};

export default Navbar;
